import { IModelEntity } from '@pit/core';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoSetting extends IModelEntity {

    paramType?: string;
    paramKey?: string;
    paramValue?: string;

    mandator?: IDtoMandator;

}
